import api from "../../api";
import { apiError } from "../../models";
import {
  DUPLICATE_PLAN_LOADING,
  DUPLICATE_PLAN_SUCCESS,
  DUPLICATE_PLAN_FAILED,
} from "../types";
import { recurringPlansDuplicateEndpoint } from "../../api/apisUrl";

export const duplicateRecurringPlan =
  (planId: string, token: string) => async (dispatch: any) => {
    dispatch({ type: DUPLICATE_PLAN_LOADING });

    try {
      const url = `${recurringPlansDuplicateEndpoint(planId)}`;

      const response = await api.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: DUPLICATE_PLAN_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      apiError(DUPLICATE_PLAN_LOADING, DUPLICATE_PLAN_FAILED, error, dispatch);
    }
  };
